import React, { useState } from 'react';
import cx from 'classnames';
// BluePrint JS
import { Popover, TextInput } from '../..';
import { chevronIcon } from '../functions/icons';
export const InlineText = ({ updateSelection, checkValidity, value, validation = {
    regexStr: '',
}, onInteractionCB = null, mode = 'light', openPosition = 'bottom-left', selectedTitle = '', translationData = {
    invalidText: '',
    placeholder: '',
}, }) => {
    const [isOpen, setIsOpen] = useState(false);
    const [inputValue, setInputValue] = useState(value || '');
    const [isInvalid, setIsInvalid] = useState(false);
    const { regexStr } = validation;
    const { invalidText, placeholder } = translationData;
    const setValueOnChange = (e) => setInputValue(e.target.value);
    const onInteraction = (nextState) => {
        if (!isOpen) {
            setIsOpen(true);
        }
        if (onInteractionCB) {
            onInteractionCB(nextState);
        }
    };
    const validateValue = () => {
        if (value !== inputValue) {
            const isValid = new RegExp(`${regexStr}`).test(`${inputValue}`);
            if (!isValid) {
                setIsInvalid(true);
                if (checkValidity) {
                    checkValidity(true);
                }
                return;
            }
            else {
                updateSelection(inputValue);
            }
        }
        setIsInvalid(false);
        checkValidity(false);
        setIsOpen(false);
    };
    return (React.createElement(Popover, { popoverClassName: "inline-dropdown_popover", position: openPosition, transitionDuration: 0, autoFocus: false, isOpen: isOpen, canEscapeKeyClose: false, onClose: validateValue, onInteraction: onInteraction },
        React.createElement("button", { className: cx('inline-dropdown_button', {
                'inline-dropdown_button--open': isOpen,
                'inline-dropdown_button--darkmode': mode === 'dark',
                'inline-dropdown_button--lightmode': mode === 'light',
            }) },
            selectedTitle !== '' ? (React.createElement("span", { className: "inline-dropdown_button--title" }, selectedTitle)) : null,
            React.createElement("span", { className: "inline-dropdown_button--item" }, value ? value : '—'),
            mode === 'light' ? (React.createElement("div", { className: "inline-dropdown_button--chevron" }, chevronIcon)) : (React.createElement("div", { className: "inline-dropdown_button--chevron" }))),
        React.createElement("div", { className: "inline-dropdown_content" },
            React.createElement("div", { className: "inline-dropdown_text-container" },
                React.createElement(TextInput, { className: cx('inline-dropdown_text-input', {
                        'inline-dropdown_text--error': isInvalid,
                    }), value: inputValue, onChange: setValueOnChange, onPressEnter: validateValue, placeholder: placeholder, autoFocus: true }),
                isInvalid && React.createElement("span", { className: "error-message" }, invalidText)))));
};
//# sourceMappingURL=InlineText.js.map